import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { GetCommentDto, GetCommentRequest, GetCommentResponse, PostCommentRequest } from '../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';

@Component({
  templateUrl: 'comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {

  commentResponse: GetCommentResponse | null = null;
  commentArray: GetCommentDto[] = [];
  adBlueAmount: number = 0;
  comment: string = '';
  popupVisibleError: boolean = false;
  errorMessage: string = '';
  loading: boolean = false;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loadComment();
  }

  loadComment() {
    this.loading = true;
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher() || this.activeUserLocalDataService.activeServiceVoucher;
    if (activeVoucher) {
      const request: GetCommentRequest = { voucherId: activeVoucher.id };
      this.courierService.getComment(request).subscribe((response: GetCommentResponse) => {
        this.commentResponse = response;
        this.commentArray = response.comment || [];
        this.loading = false;
      }, error => {
        console.error('Error fetching comments:', error);
        this.loading = false;
      });
    } else {
      console.error('Active voucher is null');
      this.navigateToVoucher();
      this.loading = false;
    }
  }

  navigateToVoucher() {
    const serviceVoucher = this.activeUserLocalDataService.activeServiceVoucher;
    const courierVoucher = this.activeUserLocalDataService.getActiveCourierVoucher();

    if (serviceVoucher) {
      this.router.navigate(['/service-voucher']);
    } else if (courierVoucher) {
      this.router.navigate(['/voucher']);
    } else {
      this.router.navigate(['/voucher']);
    }
  }

  saveClick() {
    const activeVoucher = this.activeUserLocalDataService.getActiveCourierVoucher() || this.activeUserLocalDataService.activeServiceVoucher;
    if (!activeVoucher) {
      this.navigateToVoucher();
      return;
    }

    const comments = this.commentArray.map(comment => comment.driverComment).join('\n');

    const request: PostCommentRequest = {
      comment: comments,
      voucherId: activeVoucher.id,
    };

    this.courierService.postComment(request).subscribe(() => {
      this.navigateToVoucher();
    });
  }
}